/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, URLSearchParams } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { Subscriber } from "rxjs/Subscriber";
// import '@api/rxjs-operators';

import { HttpThresholdService } from '../services/http-threshold.service';
import { SearchResult } from './../models/search-result';

/**
* Service for global search
*/
@Injectable()
export class SearchThresholdService {

    /**
     * Create the new instance of SearchThresholdService
     * @param http The instance of Http
     */
    constructor(private http: HttpThresholdService) {
    }


    /**
     * @param searchPhrase The search phrase to use to do the full text search.
     * @param take Take parameter for paging
     * @param skip Skip parameter for paging
     * @return Return an array of SearchEntries
     */
    search(searchPhrase: string, take: number, skip: number, categories?: string[]): Observable<SearchResult> {
        console.log('[SearchThresholdService]: Searching', searchPhrase);

        let params: URLSearchParams = new URLSearchParams();
        params.set('searchPhrase', searchPhrase);
        params.set('take', String(take));
        params.set('skip', String(skip));

        if (categories && categories.length > 0) {
            categories.forEach(cat => params.append('categories', cat));
        }

        return this.http.get('/api/search', { search: params })
            .map(response => response.json() );
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/search-threshold.service.ts